import React from 'react';
import Contact from '../components/Contact';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { SITE_URL } from '../config/site';
import './PageStyles.css';

const ContactPage = () => {
  const { t } = useLanguage();

  return (
    <>
      <SEO
        title="Contact Us - Dr. Muyabin Dental Care"
        description="Get in touch with Dr. Muyabin for appointments, inquiries, or dental care questions. Located in Dar es Salaam, Tanzania."
        keywords="contact dentist Tanzania, dental appointment Dar es Salaam, Dr. Muyabin contact"
        url={`${SITE_URL}/contact`}
      />
      <div className="page-container">
        <PageHero
          title={t('pages.contactTitle', 'Contact Us')}
          subtitle={t('pages.contactSubtitle', 'Get in touch with us for appointments or inquiries')}
          breadcrumb={[
            { label: 'Home', href: '/' },
            { label: t('nav.contact') },
          ]}
        />
        <Contact />
      </div>
    </>
  );
};

export default ContactPage;
